// extracted by mini-css-extract-plugin
module.exports = {"print_article":"p4Wx3","fontstyling":"MRCIT","fonticon_margin":"IDsI0","active":"gfVb7","dropdown":"s9FOM","closeBtn":"lTLxG"};